export default __webpack_public_path__ + "static/media/four.2c32663a.svg";